import { Button } from "src/components";
import crossIcon from "../../../assets/cross.svg";

const NetAmountCompare = ({
  onCloseModal,
  handleApproveInvoice,
  calculatedTotal,
  entryNetAmount,
  isLoading,
}: {
  onCloseModal: () => void;
  handleApproveInvoice: () => void;
  calculatedTotal: string | number;
  entryNetAmount: string | number;
  isLoading: boolean;
}) => {
  const diff = Math.abs(Number(entryNetAmount) - Number(calculatedTotal));
  const greaterValue = Number(entryNetAmount) > Number(calculatedTotal) ? entryNetAmount : calculatedTotal;
  const percentage = (diff / Number(greaterValue)) * 100;
  return (
    <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Approve Invoice</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      {entryNetAmount !== calculatedTotal && (
         <p className="text-sm mb-2 font-normal text-[#666666]">
          The entry amount{" "}
          <span className={Number(entryNetAmount) > Number(calculatedTotal) ? 'text-red-600' : 'text-[#8051FF]'}>
            ({entryNetAmount})
          </span>{" "}
          differs from the approval net amount{" "}
          <span className={Number(entryNetAmount) > Number(calculatedTotal) ? 'text-red-600' : 'text-[#8051FF]'}>
            ({calculatedTotal})
          </span>
          . Difference is{" "}
          <span className={Number(entryNetAmount) > Number(calculatedTotal) ? 'text-red-600' : 'text-[#8051FF]'}>
            ({diff?.toFixed(2)})
          </span>{" "}
          which is{" "}
          <span className={Number(entryNetAmount) > Number(calculatedTotal) ? 'text-red-600' : 'text-[#8051FF]'}>
            ({percentage?.toFixed(2)})
          </span>% Do you want to approve this order?
        </p>
      )}
      {entryNetAmount == calculatedTotal && (
        <p className="text-sm mb-2 font-normal text-[#666666]">
          The entry amount <span className="text-[#8051FF]">({entryNetAmount})</span> is similar to the approval net amount{" "}
          <span className="text-[#8051FF]">({calculatedTotal})</span>. Do you want to approve this order?
        </p>
      )}

      <div className="flex justify-end gap-x-2">
        <Button loaderSize="small" isLoading={isLoading} className="text-white bg-[#8051FF] mt-4" onClick={handleApproveInvoice}>
          Proceed
        </Button>
        <Button className="bg-[#f5f5f5]  mt-4" onClick={onCloseModal}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default NetAmountCompare;
